import styled from "styled-components";
import { Skeleton as MuiSkeleton } from "@mui/material";

export const Container = styled.div`
  width: 100%;
  height: 100%;
  padding: 0 1rem;
`;

export const Content = styled.div`
  margin-top: 1.5rem;
  padding-bottom: 2rem;
`;

export const Card = styled.div`
  background-color: ${({ theme }) => theme.backgroundColor};
  border-radius: 10px;
  padding: 1.5rem;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);

  .error-message {
    color: #ff0000;
    margin: 1rem 0;
    text-align: center;
  }

  .no-results {
    margin: 2rem 0;
    text-align: center;
    color: ${({ theme }) => theme.fontColor};
  }
`;

export const SearchBar = styled.div`
  display: flex;
  margin-bottom: 2rem;

  input {
    flex: 1;
    height: 3rem;
    padding: 0 1rem;
    border-radius: 6px 0 0 6px;
    border: 1px solid ${({ theme }) => theme.topElementsColor};
    background-color: ${({ theme }) => theme.bottomColor};
    color: ${({ theme }) => theme.fontColor};
    font-size: 1rem;

    &:focus {
      outline: none;
      border-color: ${({ theme }) => theme.primary};
    }
  }

  button {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    height: 3rem;
    padding: 0 1.5rem;
    background-color: ${({ theme }) => theme.primary};
    color: #fff;
    border: none;
    border-radius: 0 6px 6px 0;
    font-weight: 600;
    cursor: pointer;
    transition: filter 0.2s;

    &:hover {
      filter: brightness(0.9);
    }
  }
`;

export const PlayerGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 1.5rem;
`;

export const PlayerCard = styled.div`
  width: 100%;
  max-width: 200px;
  margin: 0 auto;
  background: linear-gradient(
    310deg,
    rgb(15 91 184 / 65%),
    rgb(27 115 218 / 65%),
    rgb(96 165 255 / 80%),
    rgb(58 138 242 / 65%)
  );
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
  transition: transform 0.3s ease;
  display: flex;
  flex-direction: column;

  &:hover {
    transform: translateY(-5px);
  }
`;

export const PlayerImage = styled.div`
  width: 100%;
  height: 140px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 15px;
  margin-bottom: 10px;

  img {
    width: 85%;
    height: 130px;
    object-fit: contain;
    filter: drop-shadow(0 5px 5px rgba(0, 0, 0, 0.3));
  }

  .no-image {
    width: 70px;
    height: 70px;
    border-radius: 50%;
    background-color: #333;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 2rem;
    font-weight: bold;
    box-shadow: 0 3px 8px rgba(0, 0, 0, 0.3);
  }
`;

export const PlayerInfo = styled.div`
  padding: 0 1rem 0.5rem;
  display: flex;
  flex-direction: column;
  flex: 1;

  h3 {
    margin: 0;
    font-size: 0.9rem;
    color: #fff;
    text-align: center;
    font-weight: 700;
    text-transform: uppercase;
  }

  .position {
    font-size: 0.8rem;
    color: #fff;
    text-align: center;
    margin-bottom: 0.5rem;
    font-weight: 500;
  }
`;

export const TeamInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0.25rem 0 0.75rem;

  img {
    width: 40px;
    height: 40px;
    object-fit: contain;
    margin-right: 0.5rem;
  }

  span {
    font-size: 0.8rem;
    color: #fff;
    font-weight: 600;
  }
`;

export const StatsInfo = styled.div`
  margin-top: auto;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 0.25rem;
  padding: 0.5rem 0;

  .stat-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0.25rem;
  }

  .stat-name {
    font-size: 0.65rem;
    color: #fff;
    font-weight: 600;
    text-transform: uppercase;
    margin-bottom: 0.1rem;
  }

  .stat-value {
    font-size: 1.1rem;
    font-weight: bold;
    color: #fff;
  }
`;

export const Skeleton = styled(MuiSkeleton)`
  background-color: rgba(255, 255, 255, 0.3);

  &::after {
    background: linear-gradient(
      90deg,
      transparent,
      rgba(255, 255, 255, 0.5),
      transparent
    );
  }
`;

export const PlayerCardSkeleton = styled.div`
  width: 100%;
  max-width: 200px;
  height: 340px;
  margin: 0 auto;
  background: linear-gradient(
    310deg,
    rgb(15 91 184 / 65%),
    rgb(27 115 218 / 65%),
    rgb(96 165 255 / 80%),
    rgb(58 138 242 / 65%)
  );
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
  padding: 15px;
  display: flex;
  flex-direction: column;
`;

export const SkeletonGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 1.5rem;
  margin-top: 1rem;
`;
